import { render, staticRenderFns } from "./DataLogger.vue?vue&type=template&id=2e115bde"
import script from "./DataLogger.vue?vue&type=script&lang=js"
export * from "./DataLogger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports